import * as angular from "angular";
import {IController} from "angular";
import {PricePlanBundleService} from "../../services/price-plan-bundle.service";
import {ServiceValidationTemplateModel} from "../../models/service-validation-template.model";
import {PricePlanDialogService} from "../../services/price-plan-dialog-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class AgentValidationsViewComponent implements IController {

  serviceValidations: ServiceValidationTemplateModel[];

  constructor(private pricePlanBundleService: PricePlanBundleService, private pricePlanDialogService: PricePlanDialogService, private confirmDialogService: ConfirmDialogService) {
  }

  $onInit() {
    this.getServiceValidations();
  }

  onAddServiceValidation() {
    this.pricePlanDialogService.createServiceValidation()
      .then((serviceValidation: ServiceValidationTemplateModel) => {
        this.createServiceValidation(serviceValidation);
      });
  }

  onEditServiceValidation(validation: ServiceValidationTemplateModel) {
    const validationCopy = angular.copy(validation);
    this.pricePlanDialogService.editServiceValidation(validationCopy)
      .then((serviceValidation: ServiceValidationTemplateModel) => {
        this.updateServiceValidation(serviceValidation);
      });
  }

  onToggleMandatory(validation: ServiceValidationTemplateModel) {
    this.updateServiceValidation(validation, false);
  }

  onDeleteServiceValidation(validation) {
    const validationCopy = angular.copy(validation);
    validationCopy.archive = true;
    this.confirmDialogService.confirm('Delete Validation', 'Are you sure you want to delete this validation?')
      .then(() => {
        this.updateServiceValidation(validationCopy, true);
      })
  }

  private createServiceValidation(validation: ServiceValidationTemplateModel) {
    this.pricePlanBundleService.createServiceValidations(validation)
      .then((serviceValidation: ServiceValidationTemplateModel) => {
        const serviceValidationCopy = angular.copy(this.serviceValidations);
        serviceValidationCopy.push(serviceValidation);
        this.serviceValidations = serviceValidationCopy;
      })
  }

  private updateServiceValidation(validation: ServiceValidationTemplateModel, isArchive?: boolean) {
    this.pricePlanBundleService.updateServiceValidations(validation, isArchive)
      .then((serviceValidation: ServiceValidationTemplateModel) => {
        const serviceValidationCopy = angular.copy(this.serviceValidations);

        const serviceValidationIndex = serviceValidationCopy.findIndex(item => item.id === validation.id);
        if (isArchive) {
          serviceValidationCopy.splice(serviceValidationIndex, 1);
        } else {
          serviceValidationCopy.splice(serviceValidationIndex, 1, serviceValidation);
        }
        this.serviceValidations = serviceValidationCopy;
      })
  }

  private getServiceValidations() {
    // this.loading = true;
    this.pricePlanBundleService.getServiceValidations()
      .then((serviceValidations: ServiceValidationTemplateModel[]) => {
        this.serviceValidations = serviceValidations || [];
      })
    // .finally(() => {
    //   this.loading = false;
    // })
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('agentValidationsView', {
    bindings: {},
    template: require('./agent-validations-view.html').default,
    controller: AgentValidationsViewComponent
  });
